import type { FunctionComponent, ReactNode } from "react";

import { checkIsPlusArticle } from "scmp-app/components/article/article-render/plus/helpers";
import type { helpersCheckIsPlusArticle$key } from "scmp-app/queries/__generated__/helpersCheckIsPlusArticle.graphql";

export type Props = {
  articleType: ReactNode;
  isPlus?: boolean;
  reference: helpersCheckIsPlusArticle$key;
  sections: ReactNode;
  withArticleType?: boolean;
  withSections?: boolean;
};

export const ArticleTypeOrSections: FunctionComponent<Props> = ({
  articleType,
  isPlus,
  reference,
  sections,
  withArticleType = true,
  withSections = true,
}) => {
  if (checkIsPlusArticle(reference) || isPlus) {
    return withArticleType ? articleType : null;
  }
  return withSections ? sections : null;
};

ArticleTypeOrSections.displayName = "ArticleTypeOrSections";
